import { styled } from "@mui/material";
import { PulseIcon } from "./PulseIcon";

const Wrapper = styled("div")<{ sx?: any }>(({ sx = {} }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  ...sx,
}));

interface Props {
  showPulse?: boolean;
  isOffline?: boolean;
  sx?: any;
}

export const UVDPulseIcon = ({ showPulse = false, sx }: Props) => {
  return <Wrapper sx={sx}>{showPulse ? <PulseIcon /> : null}</Wrapper>;
};
